import { FlagsV2Context, useFlagsV2ContextQuery } from "@/utils/hooks/use-flags-grpc";
import React, { PropsWithChildren } from "react";

/**
 * This is designed to be a singleton, only used once in the root of the project in _app.tsx,
 * rendered by the NetworkingWrapper.
 */
export const FlagsV2Wrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const flagChecker = useFlagsV2ContextQuery();
  return <FlagsV2Context.Provider value={flagChecker}>{children}</FlagsV2Context.Provider>;
};
